import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const FlagIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      {/* Flag rod/pole */}
      <line
        x1="4.1875"
        y1="3"
        x2="4.1875"
        y2="15.5"
        stroke="currentColor"
        strokeWidth="0.875"
        strokeLinecap="round"
      />
      {/* Flag shape */}
      <path
        d="M6.375 3.3125C7.30251 3.3125 8.36504 3.68238 9.38867 4.04395C9.78984 4.18572 10.196 4.33009 10.5674 4.4375C10.9329 4.54321 11.302 4.625 11.625 4.625H11.626C12.3509 4.62278 13.0686 4.47647 13.7363 4.19434C13.7446 4.19085 13.7538 4.18962 13.7627 4.19043C13.7717 4.19127 13.7806 4.19423 13.7881 4.19922C13.7955 4.20419 13.8014 4.21087 13.8057 4.21875C13.8099 4.22661 13.8124 4.23522 13.8125 4.24414V10.2422L13.8076 10.2734C13.8046 10.2833 13.8006 10.293 13.7949 10.3018C13.7833 10.3194 13.7664 10.3333 13.7471 10.3418L13.7461 10.3428C13.5406 10.4326 12.7329 10.75 11.625 10.75C11.0274 10.75 10.2567 10.5707 9.36328 10.3594C8.39368 10.1303 7.323 9.875 6.375 9.875C5.32463 9.875 4.74692 10.0336 4.45312 10.1592L4.1875 10.2725V3.86328L4.19531 3.80664C4.2002 3.7884 4.20731 3.77042 4.2168 3.75391C4.23562 3.72125 4.26249 3.69398 4.29492 3.6748C4.53651 3.53445 5.11904 3.3125 6.375 3.3125Z"
        stroke="currentColor"
        strokeWidth="0.875"
      />
    </svg>
  );
};

export default FlagIcon;
